import Investment from '../schemes/investmentScheme';
import Building from '../schemes/buildingScheme';
import Floors from '../schemes/floorsScheme';
import Floor from '../schemes/floorScheme';

import buildingsMap from '@/maps/balticwave/buildings/estate.vue';

import map1 from '@/maps/balticwave/buildings/balticwave/3d/map1.vue';
import map2 from '@/maps/balticwave/buildings/balticwave/3d/map2.vue';
import map3 from '@/maps/balticwave/buildings/balticwave/3d/map3.vue';

import p2 from '@/maps/balticwave/buildings/balticwave/floors/p2.vue';
import p3 from '@/maps/balticwave/buildings/balticwave/floors/p3.vue';
import p4 from '@/maps/balticwave/buildings/balticwave/floors/p4.vue';
import p5 from '@/maps/balticwave/buildings/balticwave/floors/p5.vue';
import p6 from '@/maps/balticwave/buildings/balticwave/floors/p6.vue';
import p7 from '@/maps/balticwave/buildings/balticwave/floors/p7.vue';
import p8 from '@/maps/balticwave/buildings/balticwave/floors/p8.vue';
import p9 from '@/maps/balticwave/buildings/balticwave/floors/p9.vue';
import p10 from '@/maps/balticwave/buildings/balticwave/floors/p10.vue';
import p11 from '@/maps/balticwave/buildings/balticwave/floors/p11.vue';
import p12 from '@/maps/balticwave/buildings/balticwave/floors/p12.vue';
import p13 from '@/maps/balticwave/buildings/balticwave/floors/p13.vue';

let floorsA = new Floors({
  streets: {
    top: '',
    bottom: '',
    left: '',
    right: '',
  },
  windroseRotation: 105,
  list: [
    new Floor({
      map: null,
      level: 0,
      backgroundImage: null,
    }),
    new Floor({
      map: null,
      level: 1,
      backgroundImage: null,
    }),
    new Floor({
      map: p2,
      level: 2,
      backgroundImage: require(`@/assets/balticwave/buildings/balticwave/floors/p2.png`),
    }),
    new Floor({
      map: p3,
      level: 3,
      backgroundImage: require(`@/assets/balticwave/buildings/balticwave/floors/p3.png`),
    }),
    new Floor({
      map: p4,
      level: 4,
      backgroundImage: require(`@/assets/balticwave/buildings/balticwave/floors/p4.png`),
    }),
    new Floor({
      map: p5,
      level: 5,
      backgroundImage: require(`@/assets/balticwave/buildings/balticwave/floors/p5.png`),
    }),
    new Floor({
      map: p6,
      level: 6,
      backgroundImage: require(`@/assets/balticwave/buildings/balticwave/floors/p6.png`),
    }),
    new Floor({
      map: p7,
      level: 7,
      backgroundImage: require(`@/assets/balticwave/buildings/balticwave/floors/p7.png`),
    }),
    new Floor({
      map: p8,
      level: 8,
      backgroundImage: require(`@/assets/balticwave/buildings/balticwave/floors/p8.png`),
    }),
    new Floor({
      map: p9,
      level: 9,
      backgroundImage: require(`@/assets/balticwave/buildings/balticwave/floors/p9.png`),
    }),
    new Floor({
      map: p10,
      level: 10,
      backgroundImage: require(`@/assets/balticwave/buildings/balticwave/floors/p10.png`),
    }),
    new Floor({
      map: p11,
      level: 11,
      backgroundImage: require(`@/assets/balticwave/buildings/balticwave/floors/p11.png`),
    }),
    new Floor({
      map: p12,
      level: 12,
      backgroundImage: require(`@/assets/balticwave/buildings/balticwave/floors/p12.png`),
    }),
    new Floor({
      map: p13,
      level: 13,
      backgroundImage: require(`@/assets/balticwave/buildings/balticwave/floors/p13.png`),
    }),
  ],
});

let buildingA = new Building({
  name: 'A',
  active: true,
  spritespin: {
    framesURL: {
      day: require('../../assets/balticwave/sprite.webp'),
      dayMobile: require('../../assets/balticwave/sprite-mobile.webp'),
    },
    framesPerRow: 10,
    frames: 41,
    breakpoints: [0, 12, 26],
    maps: [map1, map2, map3],
    points: [
      // [
      //   { name: 'Point 1', X: '50%', Y: '50%' },
      //   { name: 'Point 2', X: '20%', Y: '30%' },
      //   { name: 'Point 3', X: '80%', Y: '80%' },
      // ],
      // [
      //   { name: 'Point 4', X: '80%', Y: '50%' },
      //   { name: 'Point 5', X: '30%', Y: '30%' },
      //   { name: 'Point 6', X: '50%', Y: '80%' },
      // ],
      // [
      //   { name: 'Point 7', X: '10%', Y: '55%' },
      //   { name: 'Point 8', X: '30%', Y: '70%' },
      //   { name: 'Point 9', X: '90%', Y: '30%' },
      // ],
    ],
    windroseInitialRotation: 70,
    reverse: true,
  },
  floors: floorsA,
});

let buildings = new Map();
buildings.set(buildingA.id, buildingA);

let investment = new Investment({
  investmentName: 'Baltic Wave',
  assetsDirectory: 'balticwave',
  flatsUrl: 'https://crm.vacationinvestments.pl/sendData.php',
  buildings: buildings,
  buildingsMap: buildingsMap,
  buildingsBackground: 'background.jpg',
});

export default investment;
